import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs/Rx";

@Injectable()
export class QueueServiceProvider {
  private _service: string = "payroll";
  private _model: string = "queuePayrollProcess";

  constructor(private nestApiProvider: NestApiProvider) {}

  public progress(): Observable<any> {
    const _method: string = "GET";
    const _func: string = "progress";
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(
      _method,
      this._model,
      _func,
      _params,
      _urlParams,
      this._service
    );
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }

  public progressUpload(): Observable<any> {
    const _method: string = "GET";
    const _func: string = "progressUpload";
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};
    const timeout: number = (5 * 60) * 1000;

    const _url = this.nestApiProvider.urlBuilder(
      _method,
      this._model,
      _func,
      _params,
      _urlParams,
      this._service
    );
    return this.nestApiProvider.request(_method, _url, _func, _params, _body, null, timeout);
  }

  public deleteProgress(): Observable<any> {
    const _method: string = "GET";
    const _func: string = "deleteProgress";
    const _params: any = {};
    const _urlParams: any = {};
    const _body: any = {};

    const _url = this.nestApiProvider.urlBuilder(
      _method,
      this._model,
      _func,
      _params,
      _urlParams,
      this._service
    );
    return this.nestApiProvider.request(_method, _url, _func, _params, _body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/payroll/queue-service/queueService-provider.ts